import { ValueDescription_T } from "@smartsuite/automation-engine-api";
import type { InputCandidate } from "../../../../types/candidate";
import {
  INPUT_APPLICATION_ID,
  INPUT_SOLUTION_ID,
} from "../../../../utils/constants";

const MS_TEAMS_INPUT_TEAM = "ms-teams-input-team";
const MS_TEAMS_INPUT_CHANNEL = "ms-teams-input-channel";

const makeEmptyStringInput = (inputId: string): InputCandidate => ({
  inputId,
  value: { values: [] },
  valueDescription: {
    type: ValueDescription_T.STRING,
    multiple: false,
  },
});

export const getDependentInputsToClear = (
  inputId: string,
): InputCandidate[] => {
  if (inputId === INPUT_SOLUTION_ID) {
    return [makeEmptyStringInput(INPUT_APPLICATION_ID)];
  }

  if (inputId === MS_TEAMS_INPUT_TEAM) {
    return [makeEmptyStringInput(MS_TEAMS_INPUT_CHANNEL)];
  }

  return [];
};
